import React from "react";
import Cta from "../cta/cta";

const ProspectingCta = () => {
  return (
    <Cta
      heading="Start building your pipeline with smarter prospecting."
      firstCta="/signup"
      firstCtaText="Subscribe Now"
      secondCta="/contact-us"
      secondCtaText="Contact us"
    />
  );
};

export default ProspectingCta;
